import React from "react";

const NotFoundPage = () => {
	return (
		<div className="flex items-center justify-center h-screen bg-gray-100">
			<div className="text-center">
				<div className="text-6xl text-red-500 font-bold">404</div>
				<div className="text-2xl text-gray-700">Page not found</div>
				<p className="text-lg text-gray-600 mt-4">
					The page you are looking for might have been removed or is temporarily
					unavailable.
				</p>
				<a
					href="/operator/admin/"
					className="text-blue-500 font-bold hover:underline mt-4 block"
				>
					Go back to Home
				</a>
			</div>
		</div>
	);
};

export default NotFoundPage;
